export const resolveEventTimeMs = (event) => {
  const raw =
    event?.timeMs ??
    event?.eventTimeMs ??
    event?.time ??
    event?.eventTime ??
    event?.eventTimestamp ??
    event?.event_time ??
    event?.timestamp ??
    event?.createdAt ??
    event?.createdOn ??
    event?.occurredAt;
  if (!raw) return Number.NaN;
  let time = typeof raw === "string" ? Date.parse(raw) : Number(raw);
  if (!Number.isFinite(time)) return Number.NaN;
  if (time > 0 && time < 1e12) time *= 1000;
  return time;
};

export const toEventPoints = (events = []) => {
  return events.map((event) => ({
    time: resolveEventTimeMs(event),
    type: event.eventValue,
  }));
};

export const buildHourlyBuckets = (events = []) => {
  if (!events.length) return [];

  const hourMs = 60 * 60 * 1000;
  const pairs = events
    .map((event) => ({ event, time: resolveEventTimeMs(event) }))
    .filter((pair) => Number.isFinite(pair.time));
  if (!pairs.length) return [];

  const times = pairs.map((pair) => pair.time);
  const min = Math.min(...times);
  const max = Math.max(...times);

  const startHour = new Date(min);
  startHour.setMinutes(0, 0, 0);
  const endHour = new Date(max);
  endHour.setMinutes(0, 0, 0);

  const startTime = startHour.getTime();
  const endTime = endHour.getTime();
  const bucketCount = Math.floor((endTime - startTime) / hourMs) + 1;
  const buckets = Array.from({ length: bucketCount }, (_, idx) => {
    const hourStartMs = endTime - idx * hourMs;
    return {
      start: new Date(hourStartMs),
      end: new Date(hourStartMs + hourMs),
      events: [],
    };
  });

  pairs.forEach(({ event, time: eventTime }) => {
    if (eventTime < startTime || eventTime >= endTime + hourMs) return;
    const bucketIndex = Math.floor((endTime - eventTime) / hourMs);
    const bucket = buckets[bucketIndex];
    if (bucket) bucket.events.push(event);
  });

  return buckets;
};
